import type { ChatSeedPreSubmitResult } from '../../chat-seed/types';

type WorkflowSeedRuntime = {
  hasUnsavedChanges: () => boolean;
  hasDraftChangesAgainstBaseline?: () => boolean;
  isNew: () => boolean;
  persistNewWorkflow?: (params: {
    folderId?: string;
  }) => Promise<ChatSeedPreSubmitResult>;
  markPersisted: () => void;
};

const runtimesByWorkflowId = new Map<string, WorkflowSeedRuntime>();

export function registerWorkflowSeedRuntime(
  workflowId: string,
  runtime: WorkflowSeedRuntime
): () => void {
  runtimesByWorkflowId.set(workflowId, runtime);
  return () => {
    if (runtimesByWorkflowId.get(workflowId) === runtime) {
      runtimesByWorkflowId.delete(workflowId);
    }
  };
}

export function getWorkflowSeedRuntime(
  workflowId: string
): WorkflowSeedRuntime | undefined {
  return runtimesByWorkflowId.get(workflowId);
}

export type { WorkflowSeedRuntime };
